import { ActionPayloadGeneric } from "@app/root-store/actions";
import { createActionSet } from "@app/root-store/actions/action-creators";

/**
 * A payload used when performing an operation on a single entity
 */
export type ActionPayload = ActionPayloadGeneric & {
    lang: string;
};

/**
 * @description Used in the action creators to generate an action type like:
 * "[Entity Management] Load Entity"
 */
const actionCategory = "Localization";

/**
 * Create the CRUD set of actions associated with the action category.
 * Must send in appropriate payload types for a single and load and result types for single and bulk.
 * A request, success and failure action are created for each CRUD operation.
 * Each action set should be deconstructed into consts from the result.
 */
export const { success: getSuccess, failure: getFailure } = createActionSet<ActionPayload, ActionPayload>(actionCategory, "load");
